import React from "react";
import parse from "html-react-parser";
import styled from "styled-components";
export default function TextWidget({ logoUrl, text, heading }) {
  return (
    <Container>
      <div className="cs_text_widget" style={{ paddingTop: '50px' }}>
        <div className="logo_text_wrapper">
          { logoUrl && <img className="classs" src={ logoUrl } alt="Logo" style={ { width: '100px', height: '100px', objectFit: 'contain', borderRadius: '50%', backgroundColor: '#fff', cursor: 'pointer' } } onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} /> }
          { text && <p className="text_p">{ parse(text) }</p> }
        </div>
        {/* {heading && <h2 className="cs_newsletter_title cs_white_color mt-3">{parse(heading)}</h2>} */ }
      </div>
    </Container>
  );
}

const Container = styled.div`
  .logo_text_wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-left: 0;
  }
  .text_p {
    margin-left: 0 !important;
    margin-top: 20px !important;
    text-align: left;
  }
  .classs {
    margin-left: 0 !important;
  }

  @media only screen and (max-width: 991px) {
    .logo_text_wrapper {
      margin: 0 auto !important;
      align-items: center !important;
      text-align: center !important;
      width: 100% !important;
    }
    .text_p {
      text-align: center !important;
      margin-top: 15px !important;
      width: 100% !important;
    }
  }
`;